export default __webpack_public_path__ + "static/media/5218235.a7b95da2.jpg";